import React, { useState, useEffect } from "react";
import axios from "axios";
import button from "../Images/button+.png";
import AddVillagesForm from "./AddVillagesForm";
import SubmitProposal from "./SubmitProposal";
import ManualBeneficiary from "./ManualBeneficiary"; // Import the beneficiary component
import { FloatingLabel } from "flowbite-react";


const RoadDetailsForm = () => {
  const [districts, setDistricts] = useState();
  const [masterdistrict, setMasterDistrict] = useState([]);
  const [mastertehsil, setMasterTehsil] = useState([]);
  const [block, setBlock] = useState();
  const [masterblock, setMasterBlock] = useState([]);
  const [error, setError] = useState(null);
  const [files, setFiles] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentStep, setCurrentStep] = useState(0); // Track the current step
  const [district, setDistrict] = useState([])
  const [compensationsId, setCompensationsId] = useState([])
  const [compensationId, setCompensationId] = useState([])
  const [tehsil, setTehsil] = useState([])
  const [village, setVillage] = useState([])
  const [initialVillages, setInitialVillages] = useState([]);
  const [insertcompensationData, setInsertCompensationData] = useState({
    
    PackageNo:"",
    RoadLengthKM:"",
    RoadName:"",
    GOUGONo:"",
    GOUGODate:"",
    GOIGONo:"",
    GOIGODate:"",
    ProposalType:"नाप भूमि",
    SanctionedAmount:"",
    SanctionedDate:"",
    StatusDate:"",
    RevenueReportFile:"",
    GOISanctionedLetterFile:"",
    GOUSanctionedLetterFile:"",
    RoadMapFile:"",
    BarChartFile:"",
    });
const [selectedRadio, setSelectedRadio] = useState({
  roadStatus: "",
  verifiedRevenue: ""
})

const [fileNames, setFileNames] = useState({
  reportByRevenueDept: '',
  stateGovGoLetter: '',
  govIndiaGoLetter: '',
  roadMap: '',
  barChart: '',
});

const handleRadioChange = (status, level) => {
  // If the same Radio is clicked, unselect it, else select the new one
  setSelectedRadio((prevState) => ({
    ...prevState,
    [status]: prevState[status] === level ? "" : level,
  }));
};


const handleDistrictsChange = (event) => {
  const selectedDistrtictId = event.target.value;
  setMasterDistrict(selectedDistrtictId);
  setMasterTehsil(""); // Reset selected state
  fetchTehsil(selectedDistrtictId); // Fetch states when country changes
};
const handleFileChange = (event, key) => {
  const file = event.target.files[0];
  if (file) {
    setFiles((prevFiles) => ({
      ...prevFiles,
      [key]: file,
    }));
    setFileNames((prevFileNames) => ({
      ...prevFileNames,
      [key]: file.name,
    }));
  }
};


const fetchDistricts = async () => {
  {
    try {
      const response = await axios.get(
        "https://backurrda.sarmar.co.in/api/MasterApi/DistrictGet"
      );
      if (response.data) {
        setMasterDistrict(response.data); // Assuming response.data is an array

      }
    } catch (error) {
      console.error("Error fetching qualifications:", error);
    }
  }
};

const fetchTehsil = async (dcode) => {
  try {
    setTehsil(""); // Reset state selection

    const response = await axios.get(
      `https://backurrda.sarmar.co.in/api/MasterApi/TehsilGet/${dcode}`
    );
    if (response.data) {
    fetchVillages();

      setMasterTehsil(response.data);


    } else {
      console.error("No Tehsil data found");
    }
  } catch (error) {
    console.error("Error fetching Tehsil:", error);
  }
};

const fetchBlock = async () => {
  try {
    setBlock(""); // Reset district selection

    const response = await axios.get(
      `https://backurrda.sarmar.co.in/api/MasterApi/BlockGet`
    );
    if (response.data) {
      setMasterBlock(response.data);
    } else {
      console.error("No district data found");
    }
  } catch (error) {
    console.error("Error fetching District:", error);
  }
};

  // Toggle modal visibility
  const toggleModal = () => {
    setIsModalOpen(prevState => !prevState);
    fetchInitialVillages(); // Refresh the villages whenever the button is clicked
    fetchVillages();

};


  // Handle Save button click
  const handleSave = () => {
    setCurrentStep(1); // Move to the Beneficiary Details step
  };

  // Step titles
  const steps = ["Road Details", "Beneficiary Details", "Submit Proposal"];

  // Handle step click
  const handleStepClick = (index) => {
    setCurrentStep(index); // Move to the clicked step
  };


  const fetchInitialCompensationId = async () => {
    try {
      const response = await axios.get('https://backurrda.sarmar.co.in/api/DetailsInsert/InitialCompensationInsert');
      setCompensationsId(response.data.insertedId);
      console.log('CompensationId',response.data.insertedId);
    } catch (error) {
      console.error('Error fetching CompensationId:', error);
    }
  };

  useEffect(() => {

    fetchInitialCompensationId();
  }, []);

  const fetchInitialVillages = async () => {
    try {
      const response = await fetch(
        `https://backurrda.sarmar.co.in/api/DetailsInsert/CompensationVillageDetailsGet?compensationId=${compensationsId}`
      );
      if (response.ok) {
        const data = await response.json();
        setInitialVillages(data); // Update state with fetched data
        console.log(data)
      } else {
        console.error("Failed to fetch villages. HTTP Status:", response.status);
      }
    } catch (error) {
      console.error("Error fetching villages:", error);
    }
  };
  
  // Move this useEffect after moving fetchInitialVillages outside
  useEffect(() => {
    fetchInitialVillages();
  }, [compensationsId]);


  useEffect(() => {

    fetchDistricts();
  }, []);

  const fetchVillages = async () => {
    try {
      const response = await axios.get(`https://backurrda.sarmar.co.in/api/MasterApi/VillageGet/${RevenueDistrictCode}/${TehsilCode}`);
      setVillage(response.data);
      console.log('fetchVillages',response.data);
    } catch (error) {
      console.error('Error fetching companies:', error);
    }
  };

  useEffect(() => {

    fetchVillages();
  }, []);

  const TehsilCode = tehsil
  const RevenueDistrictCode = districts
  console.log('TehsilCode',tehsil)
  console.log('RevenueDistrictCode',districts)

  const insertCompensation = async () => {
    debugger
    // Create a FormData object to handle the files and other form data
    const formData = new FormData();
  
    // Append form fields to the formData object
    const payload = {
      ...insertcompensationData,
      IntialCompensationId: compensationsId,
      RevenueDistrictCode: districts,
      TehsilCode: tehsil,
      BlockId: block,
      RoadStatus: selectedRadio.roadStatus,
      VerifiedByRevenue: selectedRadio.verifiedRevenue,
    };

  
    // Append other form data to the FormData object
    Object.keys(payload).forEach((key) => {
      formData.append(key, payload[key]);
    });
  
    // Append the files dynamically based on the state
    Object.keys(files).forEach((doc) => {
      if (files[doc]) {
        formData.append(doc, files[doc]);
      }
    });
    console.log("Files object: ", files);

  
    try {
      debugger
      const response = await axios.post(
        "https://backurrda.sarmar.co.in/api/DetailsInsert/InsertCompensationDetails",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data", // Ensure content type is set for file upload
          },
        }
      );
      console.log(response);
      console.log(response.data.compensationId);
      setCompensationId(response.data.compensationId)
      debugger
  
      if (response.status === 200 && response.data) {
        return (response.data.compensationId);
        // console.log('object',compensationID)
      } else {
        console.error("Compensation ID not found in response.");
        throw new Error("Compensation ID not found");
      }
    } catch (err) {
      console.error("Error in Insert Compensation Data API:", err);
      throw err;
    }
  };
  
  
  useEffect(() => {
    fetchDistricts();
    fetchTehsil();
    fetchBlock();
  }, []);

  const handleSubmit = async (e) => {
    debugger
    e.preventDefault();
    setError(null);

    // const formData = new FormData();
    // Object.entries(files).forEach(([key, file]) => {
    //   formData.append(key, file);
    // });

    try {
      debugger
      const  compnestaionID  = await insertCompensation();
      console.log(compnestaionID);

      alert("Save Compensation Data");
      setCurrentStep(1);
      // Navigate("");
    } catch (err) {
      console.log("Error in Add Compensation Data:", err);
      setError(err.message);
      alert("Failed to Add Compensation Data");
    }
  };

     

    // const url = `https://backurrda.sarmar.co.in/api/MasterApi/TehsilGet/${value}`;

    // axios.get(url)
    //   .then((response) => {
    //     console.log("Tehsil: ", response.data);
    //     setTehsil(response.data);
        
    //   })
    //   .catch((err) => {
    //     console.error('Response Error: ', err.response ? err.response.data : err.message);
    //     toast.error("Failed to load Tehsil.");
    //   });

    const getFileUrl = (filePath) => {
      if (!filePath) return null; // Return null if the file path is empty
      const fileName = filePath.split("\\").pop(); // Extract file name
      return `https://backurrda.sarmar.co.in/api/Files/view/${fileName}`;
    };

  return (
    <div className="p-6">
      {/* Stepper */}
      <div className="flex justify-between items-center mb-6">
  {steps.map((step, index) => (
    <div
      key={index}
      className={`flex items-center ${
        index <= currentStep ? "cursor-pointer" : "cursor-not-allowed"
      }`}
      onClick={() => {
        if (index <= currentStep) {
          handleStepClick(index); // Allow navigation only if the step is green
        }
      }}
    >
      <div
        className={`w-8 h-8 flex items-center justify-center rounded-full text-white font-bold ${
          index <= currentStep ? "bg-green-500" : "bg-gray-300"
        }`}
      >
        {index + 1}
      </div>
      <span
        className={`ml-2 font-medium ${
          index === currentStep ? "text-green-500" : "text-gray-500"
        }`}
      >
        {step}
      </span>
      {index < steps.length - 1 && (
        <div className="w-72 border-t border-gray-300 border-dashed mx-2"></div>
      )}
    </div>
  ))}
</div>



      {/* Conditional Rendering Based on Step */}
      {currentStep === 0 && (
        <>
          {/* Road Details Form */}
          {/* Form Section */}
          <div className="grid grid-cols-10 gap-4 mb-6">
          <div className="relative col-span-2">
              <div className="form-floating">
                <select
                  className="form-select block w-full px-2.5 pb-2.5 pt-5 text-sm text-gray-900 bg-gray-50 dark:bg-gray-700 border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                  id="floatingSelect"
                  value={districts}
                  onChange={(e) => {
                    const selectedDistrict = e.target.value;
                    setDistricts(selectedDistrict);
                    if (selectedDistrict) {
                      fetchTehsil(selectedDistrict);
                    } else {
                      setMasterTehsil([]);
                    }
                  }}
                >
                  <option value="">Select</option>
                  {masterdistrict.map((district) => (
                    <option key={district.dcode} value={district.dcode}>
                      {district.DistrictName}
                    </option>
                  ))}
                </select>
                <label
                  htmlFor="floatingSelect"
                  className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] start-2.5 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto"
                >
                  District
                </label>
              </div>
            </div>
            <div className="relative col-span-2">
              <select
                id="floating_select"
                className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-gray-50 dark:bg-gray-700 border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                disabled={!mastertehsil.length}
                value={tehsil}
                onChange={(e) => {
                  setTehsil(e.target.value);
                  fetchVillages();
                }}
              >
                <option value="">Select</option>
                {mastertehsil.map((tehsil) => (
                  <option key={tehsil.Tehsilcode} value={tehsil.Tehsilcode}>
                    {tehsil.TehsilName}
                  </option>
                ))}
              </select>
              <label
                htmlFor="floating_select"
                className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] left-2.5 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4"
              >
                Tehsil
              </label>
            </div>
            <div className="relative col-span-2">
              <select
                id="floating_select"
                className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-gray-50 dark:bg-gray-700 border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                disabled={!mastertehsil.length}
                value={block}
                onChange={(e) => {
                  setBlock(e.target.value);
                }}
              >
                <option value="">Select</option>
                {masterblock.map((block) => (
                  <option key={block.BlockID} value={block.BlockID}>
                    {block.BlockName}
                  </option>
                ))}
              </select>
              <label
                htmlFor="floating_select"
                className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] left-2.5 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4"
              >
                Block
              </label>
            </div>
            <div className="col-span-2">
              {/* <input
                type="text"
                className="w-full p-2 border rounded"
                placeholder="Enter package no."
                value={insertcompensationData.PackageNo}
                onChange={(e) => {
                  setInsertCompensationData({
                    ...insertcompensationData,
                    PackageNo: e.target.value,
                  });
                }}
              /> */}
              <FloatingLabel
                variant="standard"
                label="Enter package no."
                value={insertcompensationData.PackageNo}
                onChange={(e) => {
                  setInsertCompensationData({
                    ...insertcompensationData,
                    PackageNo: e.target.value,
                  });
                }}
              />
            </div>

            <div className="col-span-2">
              {/* <input
                type="text"
                className="w-full p-2 border rounded"
                placeholder="Enter road length"
                value={insertcompensationData.RoadLengthKM}
                onChange={(e) => {
                  setInsertCompensationData({
                    ...insertcompensationData,
                    RoadLengthKM: e.target.value,
                  });
                }}
              /> */}
              <FloatingLabel
                variant="standard" 
                type="number"
                label="Enter road length in KM"
                value={insertcompensationData.RoadLengthKM}
                onChange={(e) => {
                  setInsertCompensationData({
                    ...insertcompensationData,
                    RoadLengthKM: e.target.value,
                  });
                }}
              />
            </div>
            <div className="col-span-4">
            <div className="relative">
              {/* <input
                type="text"
                className="w-full p-2 border rounded"
                placeholder="Enter road name"
                value={insertcompensationData.RoadName}
                onChange={(e) => {
                  setInsertCompensationData({
                    ...insertcompensationData,
                    RoadName: e.target.value,
                  });
                }}
              /> */}

              <FloatingLabel
                variant="standard"
                label="Enter road name"
                // className=""
                value={insertcompensationData.RoadName}
                onChange={(e) => {
                  setInsertCompensationData({
                    ...insertcompensationData,
                    RoadName: e.target.value,
                  });
                }}
              />
            </div>
            </div>
            <div className="col-span-2 ">
              {/* <input
                type="text"
                className="w-1/2 p-2 border"
                placeholder="Enter G.O. number"
                value={insertcompensationData.GOUGONo}
                onChange={(e) => {
                  setInsertCompensationData({
                    ...insertcompensationData,
                    GOUGONo: e.target.value,
                  });
                }}
              /> */}
              
              <FloatingLabel
                variant="standard"
                label="Enter G.O. Number"
                className=""
                value={insertcompensationData.GOUGONo}
                onChange={(e) => {
                  setInsertCompensationData({
                    ...insertcompensationData,
                    GOUGONo: e.target.value,
                  });
                }}
              />
              </div>
              <div className="col-span-2">
                

              {/* <input
                type="date"
                className="w-1/2 p-2 border"
                value={insertcompensationData.GOUGODate}
                onChange={(e) => {
                  setInsertCompensationData({
                    ...insertcompensationData,
                    GOUGODate: e.target.value,
                  });
                }}
              /> */}
              <FloatingLabel
                variant="standard"
                type="date"
                label="G.O. Date"
                // className=""
                value={insertcompensationData.GOUGODate}
                onChange={(e) => {
                  setInsertCompensationData({
                    ...insertcompensationData,
                    GOUGODate: e.target.value,
                  });
                }}
              />
              </div>

              <div className="col-span-2  rounded">
              {/* <input
                type="text"
                className="w-1/2 p-2 border"
                placeholder="Gov india G.O. number"
                value={insertcompensationData.GOIGONo}
                onChange={(e) => {
                  setInsertCompensationData({
                    ...insertcompensationData,
                    GOIGONo: e.target.value,
                  });
                }}
              /> */}
              <FloatingLabel
                variant="standard"
                label="Gov India G.O. Number"
                className="w-full"
                value={insertcompensationData.GOIGONo}
                onChange={(e) => {
                  setInsertCompensationData({
                    ...insertcompensationData,
                    GOIGONo: e.target.value,
                  });
                }}
              />
              </div>
              <div className="col-span-2">
                
              <FloatingLabel
                variant="standard"
                type="date"
                label="Gov India G.O. Number Date"
                className="w-full"
                value={insertcompensationData.GOIGODate}
                onChange={(e) => {
                  setInsertCompensationData({
                    ...insertcompensationData,
                    GOIGODate: e.target.value,
                  });
                }}
              />
              {/* <input
                type="date"
                className="w-1/2 p-2 border"
                value={insertcompensationData.GOIGODate}
                onChange={(e) => {
                  setInsertCompensationData({
                    ...insertcompensationData,
                    GOIGODate: e.target.value,
                  });
                }}
              /> */}
            </div>

            <div className="relative col-span-2">
              <select
                id="floating_select"
                className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-gray-50 dark:bg-gray-700 border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                
              >
                <option >Proposal Type</option>
                <option>नाप भूमि</option>
              </select>
              <label
                htmlFor="floating_select"
                className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] left-2.5 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4"
              >
                Proposal Type
              </label>
            </div>
            <div className="col-span-2">
              {/* <input
                type="tel"
                className="w-full p-2 border rounded"
                placeholder="Sanctioned amount"
                value={insertcompensationData.SanctionedAmount}
                onChange={(e) => {
                  setInsertCompensationData({
                    ...insertcompensationData,
                    SanctionedAmount: e.target.value,
                  });
                }}
                  
              /> */}
             
              <FloatingLabel
                variant="standard"
                type="number"
                label="Sanctioned Amount in Lakhs"
                value={insertcompensationData.SanctionedAmount}
                onChange={(e) => {
                  setInsertCompensationData({
                    ...insertcompensationData,
                    SanctionedAmount: e.target.value,
                  });
                }}
              />
            </div>
            <div className="col-span-2">
              {/* <input
                type="date"
                className="w-full p-1.5 border rounded"
                value={insertcompensationData.SanctionedDate}
                onChange={(e) => {
                  setInsertCompensationData({
                    ...insertcompensationData,
                    SanctionedDate: e.target.value,
                  });
                }}
              /> */}
              {/* <Datepicker
                value={insertcompensationData.SanctionedDate}
                onChange={(e) => {
                  setInsertCompensationData({
                    ...insertcompensationData,
                    SanctionedDate: e.target.value,
                  });
                }}
              /> */}
              <FloatingLabel
                variant="standard"
                type="date"
                label="Sanctioned Date"
                // className=""
                value={insertcompensationData.SanctionedDate}
                onChange={(e) => {
                  setInsertCompensationData({
                    ...insertcompensationData,
                    SanctionedDate: e.target.value,
                  });
                }}
              />
            </div>

            <div className="col-span-2 justify-center items-center">
              <button
                className="flex border rounded-lg text-[#241C68] px-4 py-2 mb-2"
                onClick={toggleModal}
              >
                Add Villages{" "}
                <img
                  src={button} // Replace this with your desired image path
                  alt="Add Icon"
                  className="w-4 h-4 m-1"
                />
              </button>
            </div>
          </div>

      {/* Additional Fields */}
      <div className="grid grid-cols-6 justify-center items-center mb-6">

       
      <div className="col-span-6 border text-left rounded-b-xl">
  <table className="w-full text-left">
    <thead className="bg-[#B4B4B4] text-center">
      <tr>
        <th className="border px-2 py-1">Name of Village</th>
        <th className="border px-2 py-1">Kilometer</th>
        <th className="border px-2 py-1">Shajra</th>
        <th className="border px-2 py-1">Consent</th>
        <th className="border px-2 py-1">Village Rate List</th>

      </tr>
    </thead>
    <tbody>
      {initialVillages.length > 0 ? (
        initialVillages.map((village, index) => (
          <tr key={index}>
            <td className="border px-2 py-1 text-center">{village.VillageNameHindi}</td>
            <td className="border px-2 py-1 text-center">{village.Km || "N/A"}</td>
            <td className="border px-2 py-1 text-center">
              {village.Shajra ? (
                <a
                  href={getFileUrl(village.Shajra)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#241C68]"
                >
                  View
                </a>
              ) : (
                "No File"
              )}
            </td>
            <td className="border px-2 py-1 text-center">
              {village.Consent ? (
                <a
                  href={getFileUrl(village.Consent)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#241C68]"
                >
                  View
                </a>
              ) : (
                "No File"
              )}
            </td>
            <td className="border px-2 py-1 text-center">
              {village.VillageRateList ? (
                <a
                  href={getFileUrl(village.VillageRateList)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#241C68]"
                >
                  View
                </a>
              ) : (
                "No File"
              )}
            </td>
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan="5" className="border px-2 py-1 text-center">
            No data available
          </td>
        </tr>
      )}
    </tbody>
  </table>
</div>

      </div>

  

      {/* Road Status */}
      <div className="mb-6">
            <label className="block font-medium mb-2">Road Status</label>
            <div className="flex items-center gap-4">
              <label>
                <input 
                type="radio" 
                name="road_status" 
                className="mr-2" 
                checked = {
                  selectedRadio.roadStatus === "Completed"
                }
                onChange={() => {
                  handleRadioChange("roadStatus" , "Completed")
                }}   
                />
                Completed
              </label>
              {selectedRadio.roadStatus === "Completed" && (
              <input 
              type="date" 
              className="mr-2 border-b"
              value={insertcompensationData.StatusDate}
              onChange={(e) => {
                setInsertCompensationData({
                  ...insertcompensationData,
                  StatusDate: e.target.value
                })
              }}
              />
            )}
              <label>
                <input 
                type="radio" 
                name="road_status" 
                className="mr-2" 
                checked = {
                  selectedRadio.roadStatus === "In Progress"
                }
                onChange={() => {
                  handleRadioChange("roadStatus" , "In Progress")
                }}                
                />
                In Progress
              </label>
              <label>
                <input 
                type="radio" 
                name="road_status" 
                className="mr-2" 
                checked = {
                  selectedRadio.roadStatus === "Maintenance"
                }
                onChange={() => {
                  handleRadioChange("roadStatus" , "Maintenance")
                }}                
                />
                Maintenance
              </label>
            </div>
          </div>

          {/* Verification */}
          <div className="mb-6">
            <label className="block font-medium mb-2">
              Verified by Revenue Department?
            </label>
            <div className="flex items-center gap-4">
              <label>
                <input 
                type="radio" 
                name="verified" 
                className="mr-2" 
                checked = {
                  selectedRadio.verifiedRevenue === "Yes"
                }
                onChange={() => {
                  handleRadioChange("verifiedRevenue" , "Yes")
                }}
                />
                Yes
              </label>
              <label>
                <input 
                type="radio" 
                name="verified" 
                className="mr-2" 
                checked = {
                  selectedRadio.verifiedRevenue === "No"
                }
                onChange={() => {
                  handleRadioChange("verifiedRevenue" , "No")
                }}
                />
                No
              </label>
            </div>
          </div>

          <div className="grid grid-cols-3 gap-4">
  {[
    { name: "📄 Report by Revenue Dept.", key: "RevenueReportFile" },
    { name: "📄 State Gov G.O. Letter", key: "GOUSanctionedLetterFile" },
    { name: "📄 Govt. of India G.O. Letter", key: "GOISanctionedLetterFile" },
    { name: "📄 Road Map", key: "RoadMapFile" },
    { name: "📄 Bar Chart", key: "BarChartFile" },
  ].map((doc, index) => (
    <div className="flex items-center justify-center" key={index}>
      <label
        htmlFor={`dropzone-file-${index}`}
        className="flex flex-col items-center justify-center w-full h-10 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:bg-white hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
      >
        <div className="flex items-center justify-center pt-5 pb-6">
          <p className="text-xs text-gray-500 dark:text-gray-400 mr-2">
            {doc.name}
          </p>
          <svg
            className="w-4 h-4 mb- text-gray-500 dark:text-gray-400"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 20 16"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
            />
          </svg>
        </div>
        <input
          id={`dropzone-file-${index}`}
          type="file"
          className="hidden"
          accept=".pdf"
          onChange={(e) => handleFileChange(e, doc.key)}
        />
      </label>
      {fileNames[doc.key] && (
        <p className="mt-2 text-xs text-gray-500">{fileNames[doc.key]}</p>
      )}
    </div>
  ))}
</div>


          {/* Modal for Add Villages */}
          {isModalOpen && (
            <div className="fixed inset-0 bg-slate-50 bg-opacity-50 flex justify-center items-center z-10">
              <div className="bg-white p-6 rounded shadow-lg relative w-11/12 md:w-1/2">
                <button
                  className="absolute top-2 right-2 text-gray-500"
                  onClick={toggleModal}
                >
                  ✕
                </button>
                <AddVillagesForm village={village} compensationsId={compensationsId}/>

              </div>
            </div>
          )}

          {/* Save Button */}
          <div className="flex justify-end">
            <button
              className="bg-blue-600 text-white px-8 py-2 rounded"
              onClick={handleSubmit}
            >
              Save
            </button>
          </div>
        </>
      )}

      {/* Beneficiary Details  Step */}
      {currentStep === 1 && <ManualBeneficiary initialVillages={initialVillages} compensationsId={compensationId} />}
      {currentStep === 2 && <SubmitProposal />}
    </div>
  );
};

export default RoadDetailsForm;
